import { useMemo } from 'react'
import { useAuthStore } from '@/store/auth.store'
import { getCurrentUserType, type UserType } from '@/utils/visibility'

/**
 * Custom hook to get the current user type for visibility filtering
 * @returns Object containing current user type and related auth information
 */
export function useUserType() {
  const { isAuthenticated, roleCode, isInstaller } = useAuthStore()

  const userType: UserType = useMemo(() => {
    return getCurrentUserType(isAuthenticated, roleCode, isInstaller)
  }, [isAuthenticated, roleCode, isInstaller])

  return {
    userType,
    isAuthenticated,
    roleCode,
    isInstaller
  }
}